import { render, staticRenderFns } from "./UtilityListComponent.vue?vue&type=template&id=86065588&scoped=true&"
import script from "./UtilityListComponent.vue?vue&type=script&lang=js&"
export * from "./UtilityListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86065588",
  null
  
)

export default component.exports